export const getArsAgentIdApi = () => {
  //ars agent id 가져오는 api
  return { apiUrl: "/ticket/ars-agent" };
};
